module.exports = __webpack_public_path__ + "static/add-meiyu-7eb1e788ab4d13ee82d05790d3ce8fdd.svg";